import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

/**
 * Struttura del portale clienti: intestazione con il marchio, fascia colorata
 * con titolo e sottotitolo (il colore è quello della coda, se noto) e contenuto
 * che si sovrappone alla fascia. Niente sidebar/menu admin: il cliente non ha
 * ruolo né permessi, solo eventualmente un pulsante di uscita se autenticato.
 */
function PortalLayout({ title, subtitle, companyName, accent, onLogout, children }) {
  const { t } = useLanguage();
  const name = companyName || t('app.title');
  const hasHero = Boolean(title || subtitle);
  return (
    <div className="portal-shell" style={{ '--pa': accent || '#1f6feb' }}>
      <header className="portal-header">
        <div className="portal-brand">
          <span className="portal-mark" aria-hidden="true">{(name || '?').trim().charAt(0).toUpperCase()}</span>
          <span className="portal-header-title">{name}</span>
        </div>
        {onLogout && (
          <button type="button" className="btn btn-secondary btn-sm" onClick={onLogout}>
            {t('portal.logout')}
          </button>
        )}
      </header>
      {hasHero && (
        <section className="portal-hero">
          <div className="portal-hero-inner">
            {title && <h1 className="portal-hero-title">{title}</h1>}
            {subtitle && <p className="portal-hero-subtitle">{subtitle}</p>}
          </div>
        </section>
      )}
      <main className={'portal-main' + (hasHero ? ' portal-main-hero' : '')}>{children}</main>
      <footer className="portal-footer">{name}</footer>
    </div>
  );
}

export default PortalLayout;
